export default {"src":"/kelp/_next/static/media/x_kelp.8bfb9ed9.svg","height":33,"width":37,"blurWidth":0,"blurHeight":0};